import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import {removeMenuItem} from './utils/menu_operations';
import {
    fetchMenuItems,
    fetchMenuClasses,
    updateTreeData,
    fetchMenus
} from './thunks';
import {changeNodeAtPath} from '../../components/helpers/tree-data-utils';
import {updateMenuItemsTreeData} from './actions';
import MenuTree from './MenuEditTree';
import DeleteMenuItemDialog from './DeleteMenuItemDialog';
import MenuSelectPageDialog from '../page-picker/page_picker';
import {onSearchPages} from '../page-picker/thunks';
import {clearPageSearchFilter} from '../page-picker/actions';
import {getFilteredDataById} from '../../components/helpers/helpers';

class MenuEdit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openDelete: false,
            node: {},
            path: [],
            selectedPageId: null
        }
    }

    componentWillMount() {
        this.props.fetchMenus();
        this.props.fetchMenuItems(this.props.match.params.id);
        this.props.fetchMenuClasses();
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    handleClickOpen = (node, path) => {
        this.setState({
            open: true,
            node: node,
            path: path,
            selectedPageId: null
        });
    };

    openRemoveDialog = (node, path) => {
        this.setState({
            openDelete: true,
            node: node,
            path: path
        });
    };

    handleClose = () => {
        this.setState({
            open: false,
        });
        this.props.clearPageSearchFilter();
    };

    handleCloseDelete = () => {
        this.setState({
            openDelete: false,
        });
    };

    submitTreeData = () => {
        this.props.updateTreeData(this.props.match.params.id, this.props.menuItemsTreeData);
        this.props.clearPageSearchFilter();
    };

    handleDeleteItem = (menuItemsTreeData, node, path) => {
        removeMenuItem(menuItemsTreeData, node, path, treeData => {
            this.props.updateMenuItemsTreeData(treeData);
        });

        this.setState({
            openDelete: false,
        });
    };

    updateMenu = (menuItemsTreeData) => {
        this.props.updateMenuItemsTreeData(menuItemsTreeData);

        this.setState({
            selectedPageId: null
        });
    }

    render() {

        const menuId = Number(this.props.match.params.id);
        const menuSiteId = Number(this.props.match.params.menuSiteId);
        let menuData = getFilteredDataById(this.props.menus, menuId);

        return (
            <div>
                {menuData !== undefined && this.props.loading !== true &&
                <MenuTree
                    menuItemsTreeData={this.props.menuItemsTreeData}
                    updateMenuItemsTreeData={this.updateMenu}
                    menuId={menuId}
                    menuType={menuData.type.name}
                    menuSite={menuData.site.name}
                    handleClickOpen={this.handleClickOpen}
                    openRemoveDialog={this.openRemoveDialog}
                    menuClasses={this.props.menuClasses}
                    classes={this.props.classes}
                    touched={this.props.touched}
                    loading={this.props.loading}
                    submitTreeData={this.submitTreeData}
                />}

                <MenuSelectPageDialog
                    open={this.state.open}
                    handleClose={this.handleClose}
                    onPick={(selectedPageId, selectedPageName) => {
                        const getNodeKey = ({treeIndex }) => treeIndex;
                        let node = this.state.node;
                        let path = this.state.path;
                        const treeData = changeNodeAtPath({
                            treeData: this.props.menuItemsTreeData,
                            path,
                            getNodeKey,
                            newNode: {...node, 'page_id': selectedPageId, 'name': selectedPageName, 'page_title': selectedPageName}
                        });
                        this.props.updateMenuItemsTreeData(treeData);
                        this.setState({
                            open: false,
                            selectedPageId: selectedPageId
                        });
                    }}
                    searchString={this.props.pageSearchCriteria}
                    onSearchPages={event => {
                        this.props.onSearchPages(event.target.value, menuSiteId);
                    }}
                    allPagesBySearchCriteria={this.props.allPagesBySearchCriteria}
                />

                <DeleteMenuItemDialog
                    menuItemsTreeData={this.props.menuItemsTreeData}
                    open={this.state.openDelete}
                    classes={this.props.classes}
                    handleClose={this.handleCloseDelete}
                    handleSubmit={this.handleDeleteItem}
                    node={this.state.node}
                    path={this.state.path}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    menuItemsTreeData: state.menus.menuItemsTreeData,
    menuClasses: state.menus.menuClasses,
    deletedNode: state.menus.deletedNode,
    deletedNodePath: state.menus.deletedNodePath,
    touched: state.menus.touched,
    loading: state.layout.ajaxCallsInProgress > 0,
    pageSearchCriteria: state.pagePicker.pageSearchCriteria,
    allPagesBySearchCriteria: state.pagePicker.allPagesBySearchCriteria,
    menus: state.menus.all,
});

export default connect(mapStateToProps, {
    fetchMenuItems,
    fetchMenuClasses,
    updateMenuItemsTreeData,
    fetchMenus,
    updateTreeData,
    onSearchPages: onSearchPages,
    clearPageSearchFilter: clearPageSearchFilter
})(withStyles(styles)(MenuEdit));


// WEBPACK FOOTER //
// ./src/containers/menus/MenuEdit.jsx